import $ from "jquery";

export const manageAccordions = () => {
  const readAllAccordionsInGroup = () =>
    document.querySelectorAll<HTMLDetailsElement>("details[name]");
  readAllAccordionsInGroup().forEach((details) => {
    details.addEventListener("toggle", () => {
      setTimeout(() => {
        const allAccordionTabs = Array.from(readAllAccordionsInGroup());
        const detailsSummary = details.querySelector<HTMLElement>("summary");
        if (detailsSummary?.ariaExpanded !== "true") {
          return;
        }
        for (const tab of allAccordionTabs) {
          const tabSummary = tab.querySelector<HTMLElement>("summary");
          if (tab != details && tabSummary?.ariaExpanded === "true") {
            tabSummary.ariaExpanded = "false";
          }
        }
      });
    });
  });

  // Automatically open accordions when anchor url is set
  const handleAccordionURLHash = () => {
    const current_hash = $(location).attr("hash");
    if (current_hash) {
      const $accordion = $("details" + current_hash);
      if ($accordion.length && $accordion[0]) {
        $accordion[0].setAttribute("open", "");
      }
    }
  };

  handleAccordionURLHash();
  addEventListener("hashchange", handleAccordionURLHash);
};
